module.exports = __webpack_public_path__ + "img/sw-b05.9e17cc94.jpg";